// extracted by css-extract-rspack-plugin
module.exports =  {"source--teacher-only":"Source-i7XE__source--teacher-only","label":"Source-ec48__label"};